export default __webpack_public_path__ + "static/media/14.ab0562cc.jpeg";